import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  it: {
    nav: {
      casa: "La casa",
      servizi: "Servizi",
      colazione: "Colazione",
      dintorni: "Dintorni",
      regole: "Regole",
      cta: "Prenota",
    },
    hero: {
      eyebrow: "Villaggio Verde · Roma",
      line1: "Welcome Love",
      line2: "House Roma",
      tagline:
        "Un rifugio romantico tra il verde di Villaggio Verde e la storia di Roma: appartamento ristrutturato con un luminoso giardino privato.",
      badge: "Casa vacanze · fino a 2 ospiti",
    },
    booking: {
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Ospiti",
      guestOne: "ospite",
      guestMany: "ospiti",
      selectDates: "Seleziona date",
      nights: "notti",
      night: "notte",
      cta: "Verifica disponibilità",
      airbnb: "Prenota su Airbnb",
      note: "Concludi in sicurezza su Booking.com o Airbnb",
      max: "Massimo 2 ospiti",
    },
    marquee: [
      "Giardino luminoso",
      "Parcheggio privato",
      "Colazione italiana",
      "Wi-Fi ultrafast",
      "Aria condizionata",
      "A due passi da Ostia Antica",
    ],
    amenities: {
      eyebrow: "Servizi",
      title: "Tutto ciò che serve per innamorarsi",
      subtitle:
        "Ogni dettaglio è pensato per un soggiorno che sa di casa, con quel tocco in più che si ricorda.",
      garden: { title: "Giardino luminoso", desc: "Illuminato la sera, perfetto per cene all'aperto" },
      kitchen: { title: "Cucina attrezzata", desc: "Tutto l'occorrente, lavatrice inclusa" },
      parking: { title: "Parcheggio privato", desc: "Posto auto riservato davanti all'ingresso" },
      wifi: { title: "Wi-Fi & clima", desc: "Connessione veloce e aria condizionata" },
      breakfastA: { title: "Colazione inclusa", desc: "Italiana, vegana o senza glutine" },
    },
    gallery: {
      eyebrow: "La casa",
      title: "Ogni angolo racconta una storia",
      subtitle: "Un appartamento appena ristrutturato, curato come una piccola boutique.",
    },
    breakfast: {
      eyebrow: "Colazione",
      title: "Il risveglio profuma di cornetti",
      body: "Ogni mattina ti aspetta una colazione preparata con amore: cornetti freschi, succhi e caffè, con opzioni per ogni esigenza.",
      chips: ["Continentale", "Italiana", "Vegana", "Senza glutine"],
    },
    surroundings: {
      eyebrow: "Dintorni",
      title: "Tra Ostia Antica e il cuore di Roma",
      subtitle:
        "Villaggio Verde è la base perfetta: il mare di Ostia, gli scavi antichi e la Capitale a portata di mano.",
      items: [
        { name: "Ostia Antica", dist: "≈ 6 km", desc: "Scavi archeologici tra i più suggestivi d'Italia" },
        { name: "Castel Romano Outlet", dist: "≈ 18 km", desc: "Shopping firmato a prezzi outlet" },
        { name: "Centro di Roma", dist: "≈ 20 km", desc: "Colosseo, Fori e la Città Eterna" },
      ],
    },
    rules: {
      eyebrow: "Regole della casa",
      title: "Poche regole, tanto relax",
      items: [
        { title: "Check-in", desc: "Dalle 14:00 alle 18:00" },
        { title: "Check-out", desc: "Dalle 08:00 alle 11:00" },
        { title: "Vietato fumare", desc: "Ambienti tutti non fumatori" },
        { title: "Animali", desc: "Ammessi su richiesta" },
        { title: "Bambini", desc: "Benvenuti a ogni età" },
      ],
    },
    footer: {
      claim: "Il tuo rifugio romantico a Roma",
      address: "Via Giuseppe Molteni 149 · 00125 Roma",
      zone: "Villaggio Verde · Acilia",
      cta: "Prenota su Booking.com",
      rights: "Tutti i diritti riservati",
    },
  },
  en: {
    nav: {
      casa: "The house",
      servizi: "Amenities",
      colazione: "Breakfast",
      dintorni: "Nearby",
      regole: "House rules",
      cta: "Book now",
    },
    hero: {
      eyebrow: "Villaggio Verde · Rome",
      line1: "Welcome Love",
      line2: "House Roma",
      tagline:
        "A romantic hideaway between the green of Villaggio Verde and the history of Rome: a renovated apartment with a bright private garden.",
      badge: "Holiday home · up to 2 guests",
    },
    booking: {
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Guests",
      guestOne: "guest",
      guestMany: "guests",
      selectDates: "Select dates",
      nights: "nights",
      night: "night",
      cta: "Check availability",
      airbnb: "Book on Airbnb",
      note: "Complete your booking securely on Booking.com or Airbnb",
      max: "Maximum 2 guests",
    },
    marquee: [
      "Bright garden",
      "Private parking",
      "Italian breakfast",
      "Ultrafast Wi-Fi",
      "Air conditioning",
      "Minutes from Ostia Antica",
    ],
    amenities: {
      eyebrow: "Amenities",
      title: "Everything you need to fall in love",
      subtitle:
        "Every detail is designed for a stay that feels like home, with that extra touch you'll remember.",
      garden: { title: "Bright garden", desc: "Lit up in the evening, perfect for outdoor dining" },
      kitchen: { title: "Full kitchen", desc: "Everything you need, washing machine included" },
      parking: { title: "Private parking", desc: "Reserved spot right at the entrance" },
      wifi: { title: "Wi-Fi & A/C", desc: "Fast connection and air conditioning" },
      breakfastA: { title: "Breakfast included", desc: "Italian, vegan or gluten-free" },
    },
    gallery: {
      eyebrow: "The house",
      title: "Every corner tells a story",
      subtitle: "A newly renovated apartment, curated like a little boutique.",
    },
    breakfast: {
      eyebrow: "Breakfast",
      title: "Wake up to the smell of croissants",
      body: "Every morning a lovingly prepared breakfast awaits: fresh pastries, juices and coffee, with options for every need.",
      chips: ["Continental", "Italian", "Vegan", "Gluten-free"],
    },
    surroundings: {
      eyebrow: "Nearby",
      title: "Between Ostia Antica and the heart of Rome",
      subtitle:
        "Villaggio Verde is the perfect base: the Ostia seaside, ancient ruins and the Capital within easy reach.",
      items: [
        { name: "Ostia Antica", dist: "≈ 6 km", desc: "Among Italy's most evocative archaeological sites" },
        { name: "Castel Romano Outlet", dist: "≈ 18 km", desc: "Designer shopping at outlet prices" },
        { name: "Rome city centre", dist: "≈ 20 km", desc: "Colosseum, Forums and the Eternal City" },
      ],
    },
    rules: {
      eyebrow: "House rules",
      title: "Few rules, plenty of relax",
      items: [
        { title: "Check-in", desc: "From 2:00 PM to 6:00 PM" },
        { title: "Check-out", desc: "From 8:00 AM to 11:00 AM" },
        { title: "No smoking", desc: "All rooms are non-smoking" },
        { title: "Pets", desc: "Allowed on request" },
        { title: "Children", desc: "All ages are welcome" },
      ],
    },
    footer: {
      claim: "Your romantic sanctuary in Rome",
      address: "Via Giuseppe Molteni 149 · 00125 Rome",
      zone: "Villaggio Verde · Acilia",
      cta: "Book on Booking.com",
      rights: "All rights reserved",
    },
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("wl-lang") || "it");

  useEffect(() => {
    localStorage.setItem("wl-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
